<template>
  <div class="menu" v-if="isHealth">
    <router-link
      v-if="access?.visits"
      to="/visits"
      :class="{ 'router-link-active': $route.name.includes('visits') }"
    >
      <div class="menu-item">
        <visits-icon />
        <div class="text">Visits</div>
      </div>
    </router-link>

    <router-link to="/users" v-if="access?.users">
      <div class="menu-item">
        <clinicians-icon />
        <div class="text">Users</div>
      </div>
    </router-link>

    <router-link to="/disciplines" v-if="access?.disciplines">
      <div class="menu-item">
        <dictionary-icon />
        <div class="text">Disciplines</div>
      </div>
    </router-link>

    <router-link
      to="/patients"
      v-if="access?.patients"
      class="patients-link"
      :class="{ 'router-link-active': $route.name.includes('patient') }"
    >
      <div class="menu-item">
        <patients-icon />
        <div class="text">Patients</div>
      </div>
    </router-link>

    <router-link to="/chats" v-if="access?.chats">
      <div class="menu-item last-item">
        <chats-icon />
        <div class="text">Chats</div>
        <div v-if="hasUnreadChats" class="chat-unread-dot" />
      </div>
    </router-link>
  </div>
  <div v-else class="menu">
    <router-link to="/clinicians" v-if="access?.clinicians">
      <div class="menu-item first-item">
        <clinicians-icon />
        <div class="text">Clinicians</div>
      </div>
    </router-link>

    <router-link to="/documents" v-if="access?.documents">
      <div class="menu-item">
        <documents-icon />
        <div class="text">Documents</div>
      </div>
    </router-link>

    <router-link to="/agencies" v-if="access?.agencies">
      <div class="menu-item">
        <agencies-icon />
        <div class="text">Agencies</div>
      </div>
    </router-link>

    <router-link to="/visits" v-if="access?.visits">
      <div class="menu-item">
        <visits-icon />
        <div class="text">Visits</div>
      </div>
    </router-link>

    <router-link to="/staffing" v-if="access?.staffing">
      <div class="menu-item">
        <clinicians-icon />
        <div class="text">Staffing</div>
      </div>
    </router-link>

    <router-link to="/dictionaries" v-if="access?.dictionaries">
      <div class="menu-item">
        <dictionary-icon />
        <div class="text">Dictionaries</div>
      </div>
    </router-link>

    <router-link to="/patients" class="patients-link" :class="{ 'router-link-active': $route.name.includes('patient') }">
      <div class="menu-item">
        <patients-icon />
        <div class="text">Patients</div>
      </div>
    </router-link>

    <router-link to="/chats" v-if="access?.chats">
      <div class="menu-item last-item">
        <chats-icon />
        <div class="text">Chats</div>
        <div v-if="hasUnreadChats" class="chat-unread-dot" />
      </div>
    </router-link>
  </div>
</template>

<script>
import CliniciansIcon from '../icons/navlinks/CliniciansIcon'
import ChatsIcon from '../icons/navlinks/ChatsIcon'
import VisitsIcon from '../icons/navlinks/VisitsIcon'
import DictionaryIcon from '../icons/navlinks/DictionaryIcon'
import AgenciesIcon from '../icons/navlinks/AgenciesIcon'
import DocumentsIcon from '../icons/navlinks/DocumentsIcon'
import PatientsIcon from '../icons/navlinks/PatientsIcon'
import { haUserRoleIds, saUserRoleIds } from '@/constants/users'

export default {
  components: {
    CliniciansIcon,
    DictionaryIcon,
    VisitsIcon,
    AgenciesIcon,
    ChatsIcon,
    DocumentsIcon,
    PatientsIcon,
  },
  props: {
    isHealth: {
      default: true,
      type: Boolean,
    },
  },
  computed: {
    hasUnreadChats() {
      return this.$store.getters.GET_CHAT_HAS_UNREAD
    },
    access() {
      const role = this.$store.getters.GET_CURRENT_ROLE
      const status = this.$store.getters.GET_CURRENT_STATUS

      if (this.isHealth) {
        const isAdmin = role === haUserRoleIds.HA_ADMIN
        const isSupervisor = role === haUserRoleIds.HA_SUPERVISOR
        const isScheduler = role === haUserRoleIds.HA_SCHEDULER
        const isQa = role === haUserRoleIds.HA_QA

        const isActive = status === 'active'

        return {
          visits: (isAdmin && isActive) || isSupervisor || isScheduler || isQa,
          users: isAdmin && isActive,
          disciplines: isAdmin,
          patients: (isAdmin && isActive) || isSupervisor || isScheduler,
          chats: true,
        }
      }

      const isAdmin = role === saUserRoleIds.SA_ADMIN

      return {
        clinicians: true,
        agencies: true,
        visits: true,
        dictionaries: isAdmin,
        staffing: isAdmin,
        documents: true,
        chats: true,
        patients: true,
      }
    },
  },
}
</script>

<style scoped lang="scss">
.menu {
  width: 244px;
  padding-top: 15px;
  background-color: #223d75;

  @media only screen and (max-width: $tablet-size) {
    width: 100%;
    height: 100%;
  }

  .menu-item {
    display: flex;
    height: 48px;
    margin-bottom: 4px;
    padding-left: 16px;
    text-align: left;
    vertical-align: middle;
    color: #ffffff;
    border-left: 3px solid transparent;

    align-items: center;

    &:hover {
      background-color: rgba(255, 255, 255, 0.08);
      color: #91c027;
      border-color: #91c027;
      cursor: pointer;

      svg {
        fill: #91c027 !important;
      }
    }

    .text {
      font-weight: 600;
      font-size: 15px;
      line-height: 48px;
      margin-left: 12px;
    }
  }

  .first-item {
    margin-top: 10px;
    @media only screen and (max-width: $tablet-size) {
      margin-top: 18px;
    }
  }

  .last-item {
    @media only screen and (max-width: $tablet-size) {
      margin-bottom: 18px;
    }
  }

  .chat-unread-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: $red-alert;
    margin-left: 8px;
    flex-shrink: 0;
  }
}

svg {
  fill: white;
}

a {
  text-decoration: none;
}

.router-link-active {
  .menu-item {
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.08);
    border-color: #91c027;
  }

  .text {
    color: #91c027;
  }

  svg {
    fill: #91c027;
  }
}

.patients-link {
  .menu-item svg {
    fill: none !important;
    stroke: white !important;
    color: white;
  }

  &:hover .menu-item {
    svg {
      fill: none !important;
      stroke: #91c027 !important;
      color: #91c027;
    }
  }

  &.router-link-active {
    .menu-item {
      cursor: pointer;
      background-color: rgba(255, 255, 255, 0.08);
      border-color: #91c027;
      color: #91c027;

      svg {
        fill: none !important;
        stroke: #91c027 !important;
        color: #91c027;
      }

      svg * {
        stroke: #91c027 !important;
        fill: #91c027 !important;
      }
    }

    .text {
      color: #91c027;
    }
  }
}
</style>
